import type { FamilyMember } from 'src/non-financial-data/v2/family/useFamilyMembers';

/**
 * How a household reads in the breadcrumb — "Tom & Anna Henderson" when the members share a
 * surname, "Tom Henderson & Anna Smith" when they don't. A client with no family, or the only
 * member of one, is named on their own.
 */
export function householdName(members: FamilyMember[], fallback: string): string {
  if (members.length < 2) {
    return fallback;
  }

  const firstNames = members.map(member => member.client.firstName?.trim() ?? '');
  const lastNames = members.map(member => member.client.lastName?.trim() ?? '');

  if (firstNames.some(name => !name)) {
    return fallback;
  }

  const sharedSurname = lastNames.every(name => name && name === lastNames[0]);
  const names = sharedSurname
    ? firstNames
    : members.map(member =>
        [member.client.firstName, member.client.lastName].filter(Boolean).join(' '),
      );

  return sharedSurname ? `${joinWithAmpersand(names)} ${lastNames[0]}` : joinWithAmpersand(names);
}

function joinWithAmpersand(names: string[]): string {
  if (names.length < 2) {
    return names.join('');
  }
  return `${names.slice(0, -1).join(', ')} & ${names[names.length - 1]}`;
}
